import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_PATH } from '../../../Constant/constants';
import { Link } from 'react-router-dom';

const MedicineList = () => {
  const [medicines, setMedicines] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const pageSize = 5;

  useEffect(() => {
    fetchMedicines();
  }, [page, search]);

  const fetchMedicines = async () => {
    const token = localStorage.getItem('authToken');
    try {
      const res = await axios.get(`${API_PATH}/medicines`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      let filtered = res.data.filter((med) =>
        med.name.toLowerCase().includes(search.toLowerCase()) ||
        med.manufacturer.toLowerCase().includes(search.toLowerCase())
      );

      const total = Math.ceil(filtered.length / pageSize);
      setTotalPages(total);

      const start = (page - 1) * pageSize;
      const paginated = filtered.slice(start, start + pageSize);

      setMedicines(paginated);
    } catch (error) {
      console.error('Error fetching medicines:', error);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure to delete this medicine?')) return;
    const token = localStorage.getItem('authToken');
    try {
      await axios.delete(`${API_PATH}/medicines/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      alert('✅ Medicine deleted!');
      fetchMedicines(); // refresh list
    } catch (err) {
      console.error('Delete failed:', err);
      alert('❌ Failed to delete');
    }
  };

  return (
    
    <div className="container w-100 mw-100 appointment-table px-2 py-2 m-0 bg-white shadow my-2" >
      <div className="row">
    <div className="">
      <div className="d-flex justify-content-between align-items-center text-center">
        <h4 className=''>Medicine List</h4>
        <Link to="/admin/home/medicines/add" className="btn btn-color">+ Add Medicine</Link>
      </div>


      <input
        className="form-control my-3"
        placeholder="Search by name or manufacturer..."
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setPage(1);
        }}
      />

      <table className=" table-bordered mt-3">
        <thead className="tableborder">
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th>Unit Price</th>
            <th>Expiry Date</th>
            <th>Manufacturer</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {medicines.length === 0 ? (
            <tr>
              <td colSpan="6" className="text-center text-muted">No medicines found.</td>
            </tr>
          ) : (
            medicines.map((med) => (
              <tr key={med.id} className='datahover'>
                <td>{med.name}</td>
                <td>{med.description}</td>
                <td>₹{med.unitPrice}</td>
                <td>{med.expiryDate}</td>
                <td>{med.manufacturer}</td>
                <td>
                  <Link to={`/admin/home/medicines/edit/${med.id}`} className="btn px-2 py-2 btn-color font-bold">Edit</Link>
                  <button onClick={() => handleDelete(med.id)} className="btn  btn-danger ms-2 font-bold">Delete</button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-between align-items-center">
          <button className="btn btn-secondary" onClick={() => setPage((p) => Math.max(p - 1, 1))} disabled={page === 1}>
            ⬅ Prev
          </button>
          <span>Page {page} of {totalPages}</span>
          <button className="btn btn-secondary" onClick={() => setPage((p) => Math.min(p + 1, totalPages))} disabled={page === totalPages}>
            Next ➡
          </button>
        </div>
      )}
    </div>
    </div>
    </div>
  );
};

export default MedicineList;
